// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelView-Header_cls1__IlHMV","cls2":"PaymentChannelView-Header_cls2__7Bwp+ PaymentChannelView-Header_cls1__IlHMV"};